module.exports = "/_next/static/images/why-health-insurance-69f1040188823994a1e9fb114a2b8fbe.jpg";